import { render, staticRenderFns } from "./QuestionBanks.vue?vue&type=template&id=676ee85f&"
import script from "./QuestionBanks.vue?vue&type=script&lang=js&"
export * from "./QuestionBanks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports